import React from 'react'
import PropTypes from 'prop-types'
import { Icon, TutorialTooltip, utils, hooks } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import PopupTooltip from '../../../components/popupTooltip'
import styles from './index.scss'

const cx = classnames.bind(styles)

const { getDisplayIndicator } = utils

const AssetType = ({ listing, showTutorial = false }) => {
  const assetDisplayInfo = getDisplayIndicator(listing) || {}
  const breakpoint = hooks.useBreakpoints()
  const isMobile = breakpoint === 'mobile'

  if (
    assetDisplayInfo.label?.toLowerCase() === 'foreclosure sale' &&
    ['mobile', 'tablet'].includes(breakpoint)
  ) {
    assetDisplayInfo.label = 'Foreclosure'
  }

  const tooltipTrigger = assetDisplayInfo.tooltipIconSvg ? (
    <img
      data-elm-id='asset_type_popup'
      className={cx('tooltip-image')}
      src={assetDisplayInfo.tooltipIconSvg}
    />
  ) : (
    <Icon data-elm-id='asset_type_popup' name='info circle' />
  )
  const tooltipContent =
    (assetDisplayInfo.description?.length && (
      <span>
        {assetDisplayInfo.description.map((value, index) => (
          <p key={`tooltip_description_${index}`}>{value}</p>
        ))}
      </span>
    )) ||
    null

  const labelContent = (
    <span className={cx('label')} data-elm-id='asset_type_label'>
      {assetDisplayInfo.label}
    </span>
  )
  return (
    <div className={cx('asset-type')}>
      <img
        src={assetDisplayInfo.iconSvg}
        className={cx('dot')}
        alt={assetDisplayInfo.label}
      />
      {showTutorial ? (
        <TutorialTooltip
          elmId='property_type_tutorial_tooltip'
          tutorial={1}
          header='Check Property Type'
          position='right center'
          mobilePosition='bottom center'
          content='Find out how this property will be sold.'
        >
          {labelContent}
        </TutorialTooltip>
      ) : (
        labelContent
      )}
      {tooltipContent && (
        <PopupTooltip
          content={tooltipContent}
          elmId='asset_type_info_tooltip'
          position={isMobile ? 'default' : 'right center'}
          trigger={tooltipTrigger}
        />
      )}
    </div>
  )
}

AssetType.propTypes = {
  listing: PropTypes.object,
  showTutorial: PropTypes.bool,
}

export default AssetType
